/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';

import {Analytics, checkIsWebView} from 'utils';
import {RudderStackEvent} from 'types';

import PartnerKycSuccessScreen from './PartnerKycSuccessScreen';
import env from 'env';
import {getSource, isInAppWebview, sendEventsToNativeApp} from 'utils/ClientAppUtils';
import {appendQueryParamToUrl} from 'utils/urlUtils';

const propTypes = {
  kycData: PropTypes.object.isRequired,
  updateStatus: PropTypes.func.isRequired,
  skipPartnerStep: PropTypes.func.isRequired,
};

const PartnerKycSuccessScreenContainer = ({
  kycData,
  updateStatus,
  skipPartnerStep,
  handleAnaylticsEvent,
}) => {
  const [timer, setTimer] = useState(8);
  const [isRedirectLoading, setRedirectLoading] = useState(false);
  const isInAppWebView = isInAppWebview();

  const isSubflowPresent = kycData.hasSubFlow && !!kycData.subFlow?.redirectUrl?.length;
  const skippingSuccessScreen =
    kycData.hasSubFlow && !!kycData.subFlow?.additionalData?.skipSuccessScreen;

  useEffect(() => {
    if (!isSubflowPresent) {
      if (timer === 0) {
        handleRedirection();
      }
      const intervalId = setInterval(() => {
        if (timer > 0) {
          setTimer(timer - 1);
        }
      }, 1000);
      return () => {
        clearInterval(intervalId);
      };
    } else {
      Analytics.trackForRudder(RudderStackEvent.KYC_COMPLETED);
    }

    if (skippingSuccessScreen) {
      handleSubFlow();
    }
  }, [timer, kycData]);

  const redirectLink = window.sessionStorage.getItem('redirectTo');
  const newAppVersion = window.sessionStorage.getItem('newAppVersion');
  const partnerProfileDetailsUrl = `${env.PARTNER_DASHBOARD_URL}/profile-details`;
  const source = getSource();

  const handleRedirection = useCallback(() => {
    if (redirectLink && redirectLink !== 'null') {
      const finalUrl = source ? appendQueryParamToUrl(redirectLink, 'source', source) : redirectLink;
      window.location.replace(finalUrl);
    } else {
      if (isInAppWebView) {
        sendEventsToNativeApp('CLOSE');
      }
      const finalUrl = source ? appendQueryParamToUrl(partnerProfileDetailsUrl, 'source', source) : partnerProfileDetailsUrl;
      window.location.replace(finalUrl);
    }
  }, [redirectLink, partnerProfileDetailsUrl, source]);

  const handleSubFlow = useCallback(() => {
    if (kycData.hasSubFlow && kycData.subFlow?.redirectUrl) {
      setRedirectLoading(true);
      let targetUrl = kycData.subFlow?.redirectUrl;
      let queryParams = '';
      if (newAppVersion === 'true') {
        queryParams += `&new_app_version=true`;
      }
      if (redirectLink !== 'null') {
        queryParams += `&redirect_to=${redirectLink}`;
      }
      if (source) {
        queryParams += `&source=${source}`;
      }

      targetUrl += `${queryParams}`;

      setTimeout(() => {
        window.location.replace(targetUrl);
      }, 1000);
    } else {
      handleRedirection();
    }
  }, [kycData]);

  return (
    <PartnerKycSuccessScreen
      kycData={kycData}
      handleSubFlow={handleSubFlow}
      handleRedirection={handleRedirection}
      isRedirectLoading={isRedirectLoading}
      isSubflowPresent={isSubflowPresent}
      timer={timer}
      skipPartnerStep={skipPartnerStep}
      skippingSuccessScreen={skippingSuccessScreen}
    />
  );
};

PartnerKycSuccessScreenContainer.propTypes = propTypes;

export default PartnerKycSuccessScreenContainer;
